import { baseApi } from "./baseApi.js"


type Category = {
    id:number
    name:string
}

const BASE = `categories`

const categoriesApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getCategories: builder.query<Category[], null>({
            query: () => `${BASE}`,
            transformResponse:(res: any)=>res.data
        }),
        getCategoriesWithProducts: builder.query<Category[], {collegeId: number}>({
            query: ({collegeId}) => `${BASE}?has_products=1&school=${collegeId}`,
            transformResponse:(res: any)=>res.data
        }),
    }),
})

export const {
    useGetCategoriesQuery,
    useGetCategoriesWithProductsQuery,
} = categoriesApi
